import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cad_ic",
  "use": "cad_ic-usage",
  "viewBox": "0 0 17 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 22\" id=\"cad_ic\"><g fill-rule=\"nonzero\" fill=\"none\"><path fill=\"#404040\" d=\"M0 0h10.973L17 6.063V22H0z\" /><path fill=\"#000\" d=\"M11 0l6 6h-6z\" /><path d=\"M7.944 15.778H5.722v-2.222H3.5v-1.112h2.222v-2.222h2.222V8h1.112v2.222h2.222v2.222H13.5v1.112h-2.222v2.222H9.056V18H7.944v-2.222zm-1.166-1.056h3.444v-3.444H6.778v3.444z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol